<template>
<!-- 1:1 문의 상세보기 팝업 -->
<div class="modal fade" id="student_selet" tabindex="-1" role="dialog" aria-labelledby="commentLabel" aria-hidden="true"  v-on:click.self="$emit('close')" @keydown.esc="$emit('close')">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <a type="button" class="close mt-10 mr-10" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">
                    <img src="../../assets/img/close.png" alt="close" class="pointer close-btn">
                </span>
            </a>
            <div class="modal-body">
                <!-- 일정 -->
                <div>
                    <h3 class="font-14 bold mb-10">1:1 문의 상세보기</h3>
                    <table class="admin-table-row">
                        <thead>
                            <tr>
                                <th>Company</th>
                                <td>{{company_name_direct}}</td>
                            </tr>
                            <tr>
                                <th>수강신청 명</th>
                                <td>{{sugang_name}}</td>
                            </tr>
                            <tr>
                                <th>이름</th>
                                <td>{{name}}</td>
                            </tr>
                            <tr>
                                <th>연락처</th>
                                <td>{{mobile}}</td>
                            </tr>
                            <tr>
                                <th>E-mail</th>
                                <td>{{email}}</td>
                            </tr>
                            <tr>
                                <th>문의 내용</th>
                                <td class="preline">
                                    {{qa_contents}}
                                </td>
                            </tr>
                            <tr>
                                <th>처리 내용</th>
                                <td>
                                    <textarea name="" v-model="as_contents" id="" class="w-300px h-50px"></textarea>
                                    <p class="txt-red">※ 작성 내용은 해당 학습자에게 발송됩니다</p>
                                </td>
                            </tr>
                            <tr>
                                <th>처리자</th>
                                <td>
                                    <label for="">
                                        <select v-model="selectHqManager" @change="changeHQManager(selectHqManager)" name="" id="">
                                            <option v-for="(item, index) of hqManagers" :key="index" :value="item">{{item.name}}</option>
                                        </select>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <th>상태</th>
                                <td>
                                    <label for="cancle">
                                        <input type="radio" v-model="status" value="X" name="button" id="">
                                        <span class="txt-13px ml-05 mr-20">미처리</span>
                                    </label>
                                    <label for="cancle">
                                        <input type="radio" v-model="status" value="N" name="button" id="">
                                        <span class="txt-13px ml-05 mr-20">처리 중</span>
                                    </label>
                                    <label for="cancle">
                                        <input type="radio" v-model="status" value="O" name="button" id="" data-toggle="modal" data-target="#sms_comment">
                                        <span class="txt-13px ml-05">처리 완료</span>
                                    </label>
                                </td>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
            <div class="modal-footer txt-center">
                <!-- <a class="pointer admin-btn-default btn" @click="openModal('mailPad')" data-toggle="modal" data-target="#mail_comment">메일 미리보기</a> -->
                <a class="pointer admin-btn-default btn" @click="openWindowPopup()">메일 미리보기</a>
                <a class="admin-btn-default btn pointer ml-05" @click="save()" data-dismiss="modal" aria-label="Close">저장</a>
            </div>
        </div>
        <sms-modal v-if="isSMSModalOpened" @close="closeModal()"></sms-modal>
        <mail-pad-modal :parentData="parentData" v-if="isMailPadModalOpened" @close="closeModal()"></mail-pad-modal>
    </div>
</div>
</template>

<script>
import SmsModal from '@/components/qna/smsModal.vue'
import MailPadModal from '@/components/qna/mailPadModal.vue'
export default {
    props: ['parentQaIdx'],
    components: {
        SmsModal,
        MailPadModal
    },
    data: () => ({
        status: 'none',
        isSMSModalOpened: false, // SMS 안내 문구 모달 on/off
        isMailPadModalOpened: false, // 메일 패드 안내 문구 모달 on/off

        company_name_direct: '', // 회사명
        sugang_name: '', // 수강신청명
        name: '', // 이름
        mobile: '', // 휴대전화번호
        email: '', // 이메일
        qa_contents: '', // 문의내용
        as_contents: '', // 답변내용
        status: '', // 처리상태 미처리 X 처리중 N 처리완료 O

        pageIdx: '', // 1:1문의를 한 수강신청 페이지 고유 idx
        managerIdx: '', // 담당 매니저 고유 idx
        managerName: '', // 담당 매니저명
        managerEmail: '', // 담당 매니저 email

        parentData: {}, // 메일패드 레이어팝업에 전달할 데이터

        hqManagers: [], // HQ매니저 전체 리스트 정보
        selectHqManager: {}, // 선택된 HQ 담당자 정보

        qaIdx: '' // 1:1 문의 고유 idx
    }),

    mounted() {
        this.qaIdx = this.parentQaIdx
        var params = {
            qaIdx: this.qaIdx,
        }

        this.axios.get(this.axios.root + this.axios.port + `/admin/qa-detail/${this.qaIdx}`, {
            params: params
        }).then(res => {
            console.log('res', res)
            if (res.data.err === 0) {
                this.company_name_direct = res.data.qaDetail.company_name_direct
                this.sugang_name = res.data.qaDetail.sugang_name
                this.name = res.data.qaDetail.name
                this.mobile = res.data.qaDetail.mobile
                this.email = res.data.qaDetail.email
                this.qa_contents = res.data.qaDetail.qa_contents
                this.status = res.data.qaDetail.status
                this.pageIdx = res.data.qaDetail.idx_itm_sugang_page_main

                if (res.data.qaDetail.as_contents) {
                    this.as_contents = res.data.qaDetail.as_contents
                }

                this.managerIdx = res.data.defaultManger.idx
                this.managerName = res.data.defaultManger.name
                this.managerEmail = res.data.defaultManger.email

                this.hqManagers = res.data.allHqMangerList.hqList

                for (var manager of this.hqManagers) {
                    if (manager.regid === res.data.defaultManger.idx) {
                        this.selectHqManager = manager
                    }
                }
            } else {
                alert(res.data.err)
            }
        }).catch(err => {
            console.log(err)
            alert(err)
        })
    },

    methods: {
        // HQ매니저 select 변경시 idx 같이 변경
        changeHQManager(data) {
            this.hqIdx = data.regid
            this.managerIdx = data.regid
            this.managerName = data.name
            this.managerEmail = data.email
            this.search()
        },

        // type에 맞게 모달 on
        openModal(type) {
            if (type === 'sms') {
                this.isSMSModalOpened = true
            } else if (type === 'mailPad') {
                this.parentData = {
                    asContents: this.as_contents,
                    qa_contents: this.qa_contents,
                    managerIdx: this.managerIdx,
                    managerName: this.managerName,
                    pageIdx: this.pageIdx,
                    qaIdx: this.qaIdx,
                    status: this.status,
                    name: this.name,
                    sugang_name: this.sugang_name,
                    email: this.managerEmail
                }
                this.isMailPadModalOpened = true
            }
        },

        // 수강자 등록 윈도우 팝업으로 열기 
        openWindowPopup() {
            let routeData = this.$router.resolve({
                name: 'list-qna-mailpad',
                query: {
                    qaIdx: this.qaIdx,
                  contents: this.as_contents
                }
            });
            window.open(routeData.href, 'window팝업', 'width=750, height=550, top:50, left:50, menubar=no, status=no, toolbar=no')
        },

        // type에 맞게 모달 off
        closeModal() {
            if (this.isSMSModalOpened) {
                this.isSMSModalOpened = false
            } else if (this.isMailPadModalOpened) {
                this.isMailPadModalOpened = false
            }
        },

        // 1:1 문의 답변 저장
        save() {
            // var params = {
            //     asContents: this.as_contents,
            //     managerIdx: this.managerIdx,
            //     managerName: this.managerName,
            //     pageIdx: this.pageIdx,
            //     qaIdx: this.qaIdx,
            //     status: this.status
            // }

            var params = new URLSearchParams()
            params.append('asContents', this.as_contents)
            params.append('managerIdx', this.managerIdx)
            params.append('managerName', this.managerName)
            params.append('pageIdx', this.pageIdx)
            params.append('qaIdx', this.qaIdx)
            params.append('status', this.status)

            this.axios.put(this.axios.root + this.axios.port + `/admin/as/${this.qaIdx}`, params).then(res => {
                console.log('res', res)
                alert('저장되었습니다.')
                this.$emit('close')
                // if (res.data.err === 0) {

                // } else {
                //     alert(res.data.err)
                // }
            }).catch(err => {
                console.log(err)
                alert(err)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
// .modal {
//     &.modal-overlay {
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         position: fixed;
//         z-index: 30;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//         background: rgba(0, 0, 0, 0.5);
//     }

//     &-window {
//         background: #fff;
//         border-radius: 4px;
//         overflow: hidden;
//     }

//     &-content {
//         padding: 10px 20px;
//     }

//     &-footer {
//         background: #ccc;
//         padding: 10px;
//         text-align: right;
//     }
// }

// .modal-enter-active,
// .modal-leave-active {
//     transition: opacity 0.4s;

//     .modal-window {
//         transition: opacity 0.4s, transform 0.4s;
//     }
// }

// .modal-leave-active {
//     transition: opacity 0.6s ease 0.4s;
// }

// .modal-enter,
// .modal-leave-to {
//     opacity: 0;

//     .modal-window {
//         opacity: 0;
//         transform: translateY(-20px);
//     }
// }
</style>
